// The starter checklist card on the hunt's left rail (shared/starter.ts).
// Small and skippable: it never blocks the hunt, and it goes away once every
// step is claimed, the player skips it, or the trainer is past its early levels.
import { STARTER_STEPS, STARTER_REWARD, starterDone, starterReady, starterOpen } from '../shared/starter.ts';
import { ITEM } from '../shared/items.ts';
import { S } from './state.ts';
import { esc, full } from './fmt.ts';
import { patch } from './dom.ts';

export function renderStarter() {
  const host = document.getElementById('startersum');
  const t = S.trainer;
  if (!host) return;
  if (!t || !starterOpen(t)) { if (!host.hidden) { patch(host, ''); host.hidden = true; } return; }
  host.hidden = false;
  const s = t.starter!;
  const ready = starterReady(t);
  const done = STARTER_STEPS.filter((x) => s.claimed.includes(x.id) || starterDone(t, x.id)).length;
  const next = STARTER_STEPS.find((x) => !starterDone(t, x.id) && !s.claimed.includes(x.id));
  patch(host, `<div class="qs-head"><b>First steps</b><span class="muted">${done} of ${STARTER_STEPS.length}</span><span class="spacer"></span><button class="link" data-act="starter-skip" title="Hide this card for good">Skip</button></div>
    <ul class="st-list">${STARTER_STEPS.map((x) => {
      const ok = s.claimed.includes(x.id) || starterDone(t, x.id);
      return `<li class="${ok ? 'done' : ''}${x === next ? ' next' : ''}" title="${esc(x.hint)}"><span class="st-box" aria-hidden="true">${ok ? '✓' : ''}</span><span class="ellip">${esc(x.text)}</span></li>`;
    }).join('')}</ul>
    ${ready.length ? `<button class="btn gold small" data-act="starter-claim">Claim ${full(STARTER_REWARD.coins * ready.length)} coins + ${STARTER_REWARD.qty * ready.length} ${esc(ITEM[STARTER_REWARD.item].name)}s</button>` : ''}`);
}
